<template>
  <v-container fluid id="routes-container">
    <v-row>
      <v-col cols="2">
        <v-select
          :items="filter_items"
          label="Search filter by"
          outlined
        ></v-select>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="mdi-magnify"
          label="Search keywords"
          @keydown.enter="searchItem"
        ></v-text-field>
      </v-col>
      <v-col background-color="light-blue">
        <v-btn dark color="indigo" @click="searchItem" class="mt-2">
          <v-icon>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>
    </v-row>
    <v-row >
      <v-col cols="12" v-if="fetchComplete">
        <InitiatorRoute
          :fetchComplete="fetchComplete"
          :initiatorRoute="selectedRoute[0]"
          :initiatorAccess="true"
        />
      </v-col>
      <v-col cols="12" v-else>
        <div class="text-center" style="margin-top: 250px">
          <v-progress-circular
            :size="100"
            :width="7"
            color="indigo"
            indeterminate
          ></v-progress-circular>
          <h2 class="mt-12 grey--text darken-3">Please wait...</h2>
        </div>
      </v-col>
    </v-row>
    <!-- USER ROUTE ASSIGNMENT -->
    <v-row>
      <v-col cols="12"> </v-col>
    </v-row>

    <div v-if="fetchComplete">
      <div v-if="getInSequenceRoutes.length > 0">
        <h5
          class="text-uppercase grey--text text--darken-3"
          style="margin-left: 110px"
        >
          [In Sequence]
        </h5>
        <v-row
          class="mt-n3"
          v-for="child in getInSequenceRoutes"
          :key="child.id"
        >
          <v-col cols="11">
            <SecondaryRoutes
              :id="child.id"
              :routeId="routeId"
              :child="child"
              :routeType="'secondaryroute'"
              :inSubRoute="false"
              :isInitiator="true"
              :userAccess="selectedRoute[0].user_id"
              :accessFrom="'mainroute'"
              :mainDocument="selectedDocuments[0]"
              :parentRouteDue="selectedRoute[0].datetime_due"
            />
          </v-col>
        </v-row>
      </div>
      <div v-if="getNonSequenceRoutes.length > 0" class="mt-n4">
        <h5
          class="text-uppercase grey--text text--darken-3"
          style="margin-left: 110px"
        ></h5>
        <v-row
          class="mt-n3"
          v-for="child in selectedRouteAssignments"
          :key="child.id"
        >
          <v-col cols="11" offset="1">
            <SecondaryRoutes
              :id="child.id"
              :routeId="routeId"
              :child="child"
              :routeType="'secondaryroute'"
              :inSubRoute="false"
              :isInitiator="true"
              :userAccess="selectedRoute[0].user_id"
              :accessFrom="'mainroute'"
              :mainDocument="selectedDocuments[0]"
              :parentRouteDue="selectedRoute[0].datetime_due"
              v-if="!child.isDeleted"
            />
          </v-col>
        </v-row>
      </div>
      <v-row v-if="secondary_route_ids.length > 0">
        <div v-for="modal in secondary_route_ids" :key="modal">
          <SubRouteDetailsModal
            :routeId="modal.toString()"
            :modalShiftX="0.01"
            :modalName="`subroute-details${modal}`"
            :isInitiator="true"
            :userAccess="selectedRoute[0].user_id"
          />
        </div>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";

  import SecondaryRoutes from "../../components/sub_routes/SecondaryRoutes";
  import SubRouteDetailsModal from "../../components/sub_routes/SubRouteDetailsModal";
  import InitiatorRoute from "../../components/routes/InitiatorRoute";

  export default {
    name: "RouteDetails2",
    components: {
      SecondaryRoutes,
      SubRouteDetailsModal,
      InitiatorRoute,
    },
    data() {
      return {
        routeId: this.$route.params.id,
        route_id: "",
        filter_items: [
          "Route Name",
          "Document Name",
          "Regional Employee",
          "Record Name",
        ],
        search: "",
        secondary_route_ids: [],
        fetchComplete: false,
      };
    },
    methods: {
      ...mapActions(["fetchSelectedRoute", "fetchUsersInOffice"]),
      searchItem() {
        alert(this.search);
      },
      scrollView(){
        if(window.location.hash) {
            var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
            var element = document.getElementById(hash);
            element.scrollIntoView({block: "center"});
        }
      }
    },
    computed: {
      ...mapGetters([
        "selectedRoute",
        "selectedDocuments",
        "selectedRouteAssignments",
        "getInSequenceRoutes",
        "getNonSequenceRoutes",
      ]),
    },
    created() {
      this.fetchSelectedRoute(this.routeId)
        .then(() => {
          this.fetchComplete = true;
          this.fetchUsersInOffice().then(()=> {
            this.scrollView()
          });
        })
        .catch(err => console.log(err));
    },
    beforeDestroy() {
      console.log("here in the before unmount");
    },
  };
</script>

<style scoped>
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .list-item {
    cursor: pointer;
    font-size: 14px;
  }

  .no-background-hover::before {
    background-color: transparent !important;
  }

  .menu-item {
    cursor: pointer;
  }

  #routes-container {
    padding: 0px 200px;
    margin-top: 50px;
  }

  @media only screen and (max-width: 1484px) {
    #routes-container {
      padding: 0px 10px;
    }
  }
</style>
